export const documentManagementMessages = {
  physicalLocations: {
    createModalTitle: 'Adicionar local',
    createButtonText: 'Adicionar local',
    createButtonIconAlt: 'Adicionar',
    createSuccessToast: 'Local criado com sucesso',
    createErrorToast: 'Erro ao criar local. Tente novamente',
    deleteDialogTitle: 'Tem certeza que deseja excluir o local?',
    deleteDialogDescription: 'A ação não pode ser desfeita.',
    deleteSuccessToast: 'Local excluído com sucesso',
    deleteErrorToast: 'Erro ao excluir local. Tente novamente',
    deleteRefusedToast: 'Não foi possível excluir o local',
    selectedLocationNotFoundToast: 'Não foi possível localizar o local selecionado.',
    nameInputLabel: (position: number) => `Local ${position}:`,
    nameInputPlaceholder: 'Informe o nome do local',
    addFieldAriaLabel: 'Adicionar novo local',
    removeFieldAriaLabel: 'Remover local',
    cancelButtonText: 'Cancelar',
    saveButtonText: 'Salvar',
  },
} as const;
